<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>REGISTROS DE PAGAMENTOS DE DESPESAS</span>
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="$emit('atualizar-listagem')"
                            ></i>
                        </span>
                    </div>
                </h4>
                <slot name="controles"></slot>
                <totais-status
                    :totaisStatus="totaisStatus"
                    v-if="totaisStatus"
                ></totais-status>
                <app-tabela
                    idTabela="tblPagamentos"
                    :itens="pagamentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <pagamento-inserir
                            :temAcessoInserir="temAcessoInserir"
                            :pagamentosServicos="pagamentosServicos"
                            :escolherFornecedor="escolherFornecedor"
                            @detalharPagamento="$emit('detalharPagamento', $event)"
                        ></pagamento-inserir>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="protocolo" slot-scope="data">
                        {{ data.protocolo }}
                        <span v-if="data.prioritario"
                            ><br /><app-status status="PRIORITÁRIO"></app-status
                        ></span>
                        <span v-if="data.especial"
                            ><br />
                            <app-status status="ESPECIAL"></app-status>
                        </span>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                        <btn-detalhar-pagamento
                            :pagamento="data"
                            :pagamentosServicos="pagamentosServicos"
                            v-if="temAcessoDetalhar"
                        ></btn-detalhar-pagamento>
                    </template>
                    <template slot="valorTotal" slot-scope="data">{{
                        data.valorTotal | currency
                    }}</template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PagamentoInserir from './PagamentoInserir'
import TotaisStatus from './TotaisStatus'
import BtnDetalharPagamento from './BtnDetalharPagamento.vue';

export default {
    props: {
        pagamentos: {
            type: Array,
            default: () => []
        },

        totaisStatus: {
            type: Object,
            default: () => ({})
        },

        showFornecedor: {
            type: Boolean,
            default: true
        },

        temAcessoDetalhar: {
            type: Boolean,
            default: false
        },

        temAcessoInserir: {
            type: Boolean,
            default: () => false
        },

        escolherFornecedor: {
            type: Boolean,
            default: () => false
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'protocolo',
                    label: 'Protocolo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'qtdDespesas',
                    label: 'Despesas',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Anexos',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                }
            ],
            itensPorPagina: 0
        }
    },
    methods: {},

    created() {
        if (!this.showFornecedor) {
            this.campos.splice(2, 1)
        }
    },

    computed: {},

    watch: {},

    components: {
        BtnDetalharPagamento,
        PagamentoInserir,
        TotaisStatus
    }
}
</script>
